export interface Testimonial {
  quote: string;
  author: string;
  location: string;
}

export const FEATURED_TESTIMONIAL: Testimonial = {
  quote:
    "Cathryn is hands down the best colorist in the South Bay. My blonde looks so natural and grows out seamlessly. I only need a touch up twice a year now!",
  author: "Jessica M.",
  location: "Manhattan Beach",
};

export const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      "The studio atmosphere is serene, private, and relaxing. She takes the time to truly listen to your goals and lifestyle. Worth every single penny.",
    author: "Lauren S.",
    location: "Hermosa Beach",
  },
  {
    quote:
      "I was nervous about embracing my grey, but Cathryn's blending technique made it look luminous and high-end rather than washed out.",
    author: "Sarah K.",
    location: "Redondo Beach",
  },
];
